// removed by extract-text-webpack-plugin
module.exports = {"dimensions":"MqsFag_HACxzmmiYOK1OE","task":"_3rhiqBlKPMBNVz3ASHN-Zj","buttonEdit":"_-r4RRF9aBMQDjNOESYuAk","removed":"_1b8QdFhbZNQrANKUDM6wS0","range":"_2OWIqqKXhLNb5Xb8FRnKey","stockRow":"_2Ves_GHeofOuHroKQk2Mnq","title":"_2vMSvTg51LqalAzaI1GFIP","goal":"_29SD0k-N_j5hH3uRDpvX1A","count":"_3xtnej5a0FzwU5_eHqrS0Y","green":"_1Y5Srqgc_B5W1UZbt8A6vd","red":"lYIltnPrlFGpZjkRrRHCu"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Order/style.scss
// module id = 1063
// module chunks = 0